import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TranslateResolver, LanguagesService } from "@ubisolutions/base";
import { catchError, map, Observable, of, switchMap } from "rxjs";
import { KeyTreeTranslationServiceService } from "@shared/business/services/key-tree-translation-service.service";

/**
 * Client translation overrides (ui.translations) first, ngx-translate otherwise.
 */
@Injectable()
export class CtTranslateResolver implements TranslateResolver {
    private readonly keyTreeTranslationService = inject(KeyTreeTranslationServiceService);
    private readonly languageService = inject(LanguagesService);
    private readonly translateService = inject(TranslateService);

    resolve(key: string, params?: Record<string, unknown>): Observable<string> {
        return this.languageService.currentLang$.pipe(
            map(currentLang => `${currentLang}.${key}`),
            switchMap(localizedKey => this.keyTreeTranslationService.checkSchemaExists(localizedKey)),
            switchMap((customTranslation) => {
                if (customTranslation) {
                    return of(customTranslation);
                } else {
                    return this.translateService.get(key, params).pipe(
                        catchError(() => of("")),
                    );
                }
            }),
            catchError(() => of("")),
        );
    }
}
